export class Notifications {
  id?: number;
  id_pqrsf?: number;
  fecha_hora?: string;
  evento?: string;
  descripcion?: string;
  id_usuario?: number;
  leida: boolean;
  colorClass: string;
  icon: string;

  constructor(log?: any) {
    this.id = log?.id ?? 0;
    this.id_pqrsf = log?.id_pqrsf ?? 0;
    this.fecha_hora = log?.fecha_hora ?? '';
    this.evento = log?.evento ?? '';
    this.descripcion = log?.descripcion ?? '';
    this.id_usuario = log?.id_usuario ?? 0;
    this.leida = log?.leida === 1 ? true : false;

    // Asignar ícono y color basado en el evento
    const eventIcons: { [key: string]: { icon: string; colorClass: string } } = {
      'Actualización de estado': { icon: 'mat:autorenew', colorClass: 'text-[#00603e]' },
      'Actualización de encargado': { icon: 'mat:person', colorClass: 'text-green-500' },
      'Inicio de respuesta': { icon: 'mat:reply', colorClass: 'text-yellow-500' },
      'Se ha finalizado el proceso': { icon: 'mat:check_circle', colorClass: 'text-[#00a451]' },
      'Nuevo proceso': { icon: 'mat:add_circle', colorClass: 'text-red-500' },
    };

    const eventInfo = eventIcons[this.evento || ''] || { icon: 'mat:info', colorClass: 'text-gray-500' };
    this.icon = eventInfo.icon;
    this.colorClass = eventInfo.colorClass;
  }
}
